import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { ItemContainer, ItemLabel, ItemValue } from ".";
import {
  DurationComponent,
  WorkOrderStatus,
} from "../../../../../components/WorkOrders/WorkOrdersTable";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import TaskPillComponent from "../TaskPillComponent";
import { getIssuePriorityText } from "../../../../../components/Issues/IssuesTable";
import {
  getAssetConditionOptions,
  getDisplayDateWithTime,
  getDistanceUnit,
} from "../../../../helpers";
import { AssetConditionValue } from "../../../AssetConditionDisplay";
import { useEffect } from "react";
import { useState } from "react";
import { postApi } from "../../../../../api/getUser";
import { LinkSpan } from "../../../form/FormElements";
import PausesTable from "../../../../../components/WorkOrders/components/PausesTable";
import ImageWithZoom from "../../../form/ImageWithZoom";
import {
  s3Url,
  repairReasonKeyMap,
  repairClassKeyMap,
  repairSiteKeyMap,
} from "../../../../constants";
import LogsPopup from "../../../../../components/WorkOrders/components/LogsPopup";
import ServiceTasksSidePanel from "./components/ServiceTasksSidePanel";
import Tooltip from "../../../Tooltip";

const WorkOrdersRightPanel = ({
  rowData,
  logs,
  setLogs,
  showLogs,
  setShowLogs,
  serviceTasks,
  setServiceTasks,
}) => {
  const { t } = useTranslation("common");

  const { orgId } = useSelector((state) => state.user);
  const { currency, distance } = useSelector((state) => state.units);
  const users = useSelector((state) => state.users?.list);

  console.log("woRowData", rowData);

  //const [serviceTasks, setServiceTasks] = useState([]);
  const [pauses, setPauses] = useState([]);
  const [completedPauses, setCompletedPauses] = useState([]);
  const [showPausesTable, setShowPausesTable] = useState(false);

  //const [logs, setLogs] = useState([]);
  const [showLogsPopup, setShowLogsPopup] = useState(false);

  //State to determine whether to show logs or old pause table
  //const [showLogs, setShowLogs] = useState(false);

  const {
    //veh_id,
    //assigned_to,
    comments,
    create_date,
    created_by,
    due_date,
    start_date,
    end_date,
    invoice_number,
    //name,
    //odo,
    po_number,
    priority,
    //service_id,
    status,
    technician_id,
    issues,
    wo_number,
    wo_img_name,
    tax,
    discount,
    wo_id,
    reminder_name,
    created_by_name,
    secondary_technicians,
    type,
    repair_reason_description,
    repair_site,
    asset_condition,
  } = rowData;

  const assetConditionOptions = getAssetConditionOptions(t);

  const assignedTo = users?.find((u) => u.user_id === technician_id)?.label;

  let assignedTechStr = "";
  let asstTechNamesArr = [];
  if (secondary_technicians?.length > 0) {
    asstTechNamesArr = secondary_technicians?.map((techId) => {
      return users?.find((u) => u.user_id === techId)?.label;
    });

    assignedTechStr = asstTechNamesArr[0];

    if (secondary_technicians?.length > 1) {
      assignedTechStr += `, +${secondary_technicians.length - 1}`;
    }

    //asstTechNamesArr = secondary_technicians?.split(",");
    // assignedTechStr = namesArr[0];
    // if (namesArr?.length > 1) {
    //   assignedTechStr += `, +${namesArr.length - 1}`;
    // }
  }

  const workOrderImgs = [];
  let woImgNames = "";
  if (wo_img_name) {
    woImgNames = wo_img_name?.split(":::");
    woImgNames?.forEach((imgName, i) => {
      workOrderImgs.push({
        id: imgName,
        url: `${s3Url}/org_${orgId}/workorder/${wo_id}/${imgName}`,
      });
    });
  }

  //Effect to fetch pauses
  useEffect(() => {
    //Logic to get pauses
    (async () => {
      const pauseApiFetchData = {
        querystring: "get_all_pauses_for_workorder",
        wo_id: wo_id,
      };
      const pauseResponse = await postApi(pauseApiFetchData, "commonNew");
      if (pauseResponse.success === 1) {
        const { user_data } = pauseResponse;
        const completedPauses = user_data.filter((p) => p.end_time);
        setPauses(user_data);
        setCompletedPauses(completedPauses);
      }
    })();
  }, [wo_id]);

  return (
    <>
      <Row>
        <Col md={12}>
          <ItemContainer className="d-flex align-items-center gap-2">
            <ItemLabel className="m-0">{`${t("work_order")}:`}</ItemLabel>
            <ItemValue>{wo_number}</ItemValue>
          </ItemContainer>
        </Col>

        {/* {!!odo && +odo !== -1000 && (
          <Col>
            <ItemContainer>
              <ItemLabel>{t("odometer")}</ItemLabel>
              <ItemValue>{`${odo} ${getDistanceUnit(distance)}`}</ItemValue>
            </ItemContainer>
          </Col>
        )} */}

        <Col>
          <ItemContainer>
            <ItemLabel>{t("work_order_priority")}</ItemLabel>
            <ItemValue>{getIssuePriorityText(priority)}</ItemValue>
          </ItemContainer>
        </Col>

        {(issues || reminder_name) && (
          <Col md={12}>
            <ItemContainer>
              <ItemLabel>
                {reminder_name ? t("assoc_reminder") : t("assoc_issue")}
              </ItemLabel>
              <ItemValue>
                <TaskPillComponent
                  stringValue={reminder_name ? reminder_name : issues}
                />
              </ItemValue>
            </ItemContainer>
          </Col>
        )}

        {/* <Col>
        <ItemContainer>
        <ItemLabel>{t("status")}</ItemLabel>
        <ItemValue>
            <WorkOrderStatus status={status} />
          </ItemValue>
        </ItemContainer>
      </Col> */}

        {!!create_date && (
          <Col md={6}>
            <ItemContainer>
              <ItemLabel>{t("created_on")}</ItemLabel>
              <ItemValue>{getDisplayDateWithTime(create_date)}</ItemValue>
            </ItemContainer>
          </Col>
        )}

        {created_by && (
          <Col md={6}>
            <ItemContainer>
              <ItemLabel>{t("created_by")}</ItemLabel>
              <ItemValue>{created_by_name}</ItemValue>
            </ItemContainer>
          </Col>
        )}

        {!!due_date && (
          <Col md={6}>
            <ItemContainer>
              <ItemLabel>{t("due_on")}</ItemLabel>
              <ItemValue>{getDisplayDateWithTime(due_date)}</ItemValue>
            </ItemContainer>
          </Col>
        )}

        {technician_id && (
          <Col>
            <ItemContainer>
              <ItemLabel>{t("assigned_to")}</ItemLabel>
              <ItemValue>{assignedTo}</ItemValue>
            </ItemContainer>
          </Col>
        )}

        {!!start_date && (
          <Col md={6}>
            <ItemContainer>
              <ItemLabel>{t("started_on")}</ItemLabel>
              <ItemValue>{getDisplayDateWithTime(start_date)}</ItemValue>
            </ItemContainer>
          </Col>
        )}

        {secondary_technicians?.length > 0 && (
          <Col md={6}>
            <ItemContainer>
              <ItemLabel>{t("asst_techs")}</ItemLabel>
              <ItemValue>
                <p>{asstTechNamesArr[0]}</p>
                {asstTechNamesArr.length > 1 && (
                  <>
                    <p>{", "}</p>
                    <Tooltip text={asstTechNamesArr.slice(1).join(",")}>
                      <p>{`+${asstTechNamesArr.length - 1}`}</p>
                    </Tooltip>
                  </>
                )}
              </ItemValue>
            </ItemContainer>
          </Col>
        )}

        {!!end_date && (
          <Col md={6}>
            <ItemContainer>
              <ItemLabel>{t("ended_on")}</ItemLabel>
              <ItemValue>{getDisplayDateWithTime(end_date)}</ItemValue>
            </ItemContainer>
          </Col>
        )}

        {!!start_date && (
          <Col md={6}>
            <ItemContainer>
              <ItemLabel>{t("duration")}</ItemLabel>
              <ItemValue>
                {<DurationComponent rowData={rowData} pauses={pauses} />}
              </ItemValue>
            </ItemContainer>
          </Col>
        )}

        {!!asset_condition && (
          <Col md={6}>
            <ItemContainer>
              <ItemLabel>{t("asset_condition")}</ItemLabel>
              <ItemValue>
                <AssetConditionValue
                  option={assetConditionOptions.find(
                    (opt) => opt.value === asset_condition,
                  )}
                />
              </ItemValue>
            </ItemContainer>
          </Col>
        )}

        {showLogs ? (
          <>
            {logs.length > 0 && (
              <Col md={12} className="mb-2">
                <ItemContainer>
                  <ItemValue>
                    <LinkSpan onClick={() => setShowLogsPopup(true)}>{`${t(
                      t("notes_prog_updates"),
                    )} (${logs.length})
                       `}</LinkSpan>
                  </ItemValue>
                </ItemContainer>
              </Col>
            )}
            {showLogsPopup && (
              <LogsPopup
                showPopup={showLogsPopup}
                setShowPopup={setShowLogsPopup}
                logs={logs}
                setLogs={setLogs}
                //user={createdBy}
                readOnly={true}
              />
            )}
          </>
        ) : (
          <>
            {pauses.length > 0 && (
              <Col md={12} className="mb-2">
                <ItemContainer>
                  {/* <ItemLabel>{t("duration")}</ItemLabel> */}
                  <ItemValue>
                    <LinkSpan onClick={() => setShowPausesTable(true)}>{`${t(
                      "paused",
                    )} ${pauses.length} ${
                      pauses.length === 1 ? t("time_tv") : t("times")
                    }`}</LinkSpan>
                  </ItemValue>
                </ItemContainer>
              </Col>
            )}
            {showPausesTable && (
              <PausesTable
                showPopup={showPausesTable}
                setShowPopup={setShowPausesTable}
                pauses={pauses}
              />
            )}
          </>
        )}
      </Row>

      {/* {serviceTasks?.map((task) => {
        return (
          <Row
            key={task.service_task_id}
            style={{
              background: taskBgColor,
              padding: "10px 0",
              margin: "0.25rem 0",
              borderRadius: "5px",
            }}
          >
            <p style={{ fontSize: "16px" }}>{task.service_task_name}</p>

            <Col md={4}>
              <ItemContainer>
                <ItemLabel>{`${t("parts")} (${currency})`}</ItemLabel>
                <ItemValue>
                  {task.partsCost ? task.partsCost : NATEXT}
                </ItemValue>
              </ItemContainer>
            </Col>

            <Col md={4}>
              <ItemContainer>
                <ItemLabel>{`${t("labor")} (${currency})`}</ItemLabel>
                <ItemValue>
                  {task.laborCost ? task.laborCost : NATEXT}
                </ItemValue>
              </ItemContainer>
            </Col>

            <Col md={4}>
              <ItemContainer>
                <ItemLabel>{`${t("tc_tv")} (${currency})`}</ItemLabel>
                <ItemValue>
                  {task.totalCost ? task.totalCost : NATEXT}
                </ItemValue>
              </ItemContainer>
            </Col>
          </Row>
        );
      })}

      {serviceTasks.length > 0 && (
        <>
          <Row
            style={{
              background: taskBgColor,
              padding: "10px 0",
              margin: "0.25rem 0",
              borderRadius: "5px",
            }}
          >
            <Col md={4}>
              <ItemContainer>
                <ItemLabel>{`${t("parts_total")}`}</ItemLabel>
                <ItemValue>
                  {parts_total ? parts_total?.toFixed(2) : 0}
                </ItemValue>
              </ItemContainer>
            </Col>
            <Col md={4}>
              <ItemContainer>
                <ItemLabel>{`${t("labor_total")}`}</ItemLabel>
                <ItemValue>
                  {labor_total ? labor_total?.toFixed(2) : 0}
                </ItemValue>
              </ItemContainer>
            </Col>
            <Col md={4}>
              <ItemContainer>
                <ItemLabel>{`${t("total")}`}</ItemLabel>
                <ItemValue>{total ? total?.toFixed(2) : 0}</ItemValue>
              </ItemContainer>
            </Col>
          </Row>
          <Row className="d-flex justify-content-end">
            <Col sm={6}>
              <ItemContainer className="d-flex gap-2 align-items-center justify-content-end">
                <ItemLabel
                  className="m-0"
                  //style={{ minWidth: "90px" }}
                >
                  {t("discount")}:
                </ItemLabel>
                <ItemValue>{`${
                  +discount ? Math.round(+discount) : 0
                } ${currency}`}</ItemValue>
              </ItemContainer>
            </Col>
          </Row>
          <Row className="d-flex justify-content-end">
            <Col sm={6}>
              <ItemContainer className="d-flex gap-2 align-items-center justify-content-end">
                <ItemLabel
                  className="m-0"
                  //style={{ minWidth: "80px" }}
                >
                  {t("tax")}:
                </ItemLabel>
                <ItemValue>{`${
                  +tax ? Math.round(+tax) : 0
                } ${currency}`}</ItemValue>
              </ItemContainer>
            </Col>
          </Row>
          <Row className="d-flex justify-content-end">
            <Col sm={6}>
              <ItemContainer className="d-flex gap-2 align-items-center justify-content-end">
                <ItemLabel
                  className="m-0"
                  //style={{ minWidth: "90px" }}
                >
                  {t("grand_total")}:
                </ItemLabel>
                <ItemValue style={{ fontWeight: 500 }}>
                  {`${total - discount + tax} ${currency}`}
                </ItemValue>
              </ItemContainer>
            </Col>
          </Row>
        </>
      )} */}
      {serviceTasks?.length > 0 && (
        <ServiceTasksSidePanel serviceTasks={serviceTasks} rowData={rowData} />
      )}

      <>
        <Row className="mt-3">
          <Col>
            <ItemLabel
              style={{ textTransform: "uppercase", letterSpacing: "0.05em" }}
            >
              {t("repair_details")}
            </ItemLabel>
          </Col>
        </Row>
        <Row>
          {repair_reason_description&& (
            <Col md={6}>
              <ItemContainer>
                <ItemLabel>{t("repair_reason")}</ItemLabel>
                <ItemValue>{repair_reason_description}</ItemValue>
              </ItemContainer>
            </Col>
          )}

          {repairClassKeyMap[type] && (
            <Col md={6}>
              <ItemContainer>
                <ItemLabel>{t("repair_class")}</ItemLabel>
                <ItemValue>{t(repairClassKeyMap[type])}</ItemValue>
              </ItemContainer>
            </Col>
          )}

          {repair_site !== -1 && repairSiteKeyMap[repair_site] && (
            <Col md={6}>
              <ItemContainer>
                <ItemLabel>{t("repair_site")}</ItemLabel>
                <ItemValue>{t(repairSiteKeyMap[repair_site])}</ItemValue>
              </ItemContainer>
            </Col>
          )}
        </Row>
      </>

      <Row>
        {comments && (
          <Col md={12}>
            <ItemContainer>
              <ItemLabel>{t("notes_tv")}</ItemLabel>
              <ItemValue>{comments}</ItemValue>
            </ItemContainer>
          </Col>
        )}

        {workOrderImgs.length > 0 && (
          <Col md={12}>
            <ItemContainer>
              <ItemLabel>{t("attachments")}</ItemLabel>
              <ItemValue>
                <div className="d-flex gap-2 flex-wrap">
                  {workOrderImgs.map((img) => {
                    return (
                      <ImageWithZoom
                        key={img.id}
                        img={img}
                        //handleDeleteImg={handleDeleteImg}
                        shouldDelete={false}
                      />
                    );
                  })}
                </div>
              </ItemValue>
            </ItemContainer>
          </Col>
        )}

        {po_number && (
          <Col md={6}>
            <ItemContainer>
              <ItemLabel>{t("purchase_order_no")}</ItemLabel>
              <ItemValue>{po_number}</ItemValue>
            </ItemContainer>
          </Col>
        )}

        {invoice_number && (
          <Col md={6}>
            <ItemContainer>
              <ItemLabel>{t("invoice_no")}</ItemLabel>
              <ItemValue>{invoice_number}</ItemValue>
            </ItemContainer>
          </Col>
        )}
      </Row>
    </>
  );
};

export default WorkOrdersRightPanel;
